import React, { Component } from 'react';
import { connect } from "react-redux";

import MediaActionsComponent from './MediaActionsComponent.jsx';
import { openPullout } from '../../Actions/stakeholderActions';
import { setVehicleDb, setBookingsDb } from '../../Actions/dataActions';
import { VCIcon, DivisionIcon } from '../Common/Buttons/TypeIcons.js';

import axios from "axios";
import moment from "moment";
import { Trans } from 'react-i18next';

//A React component will allow us to quickly iterate and change our code. It provides 
class OutstandingMediaRow extends Component {
    constructor(props) {
        super(props);

        this.generateTitle = this.generateTitle.bind(this);
        this.openBooking = this.openBooking.bind(this);

        this.state = {
        };
    }

    componentDidMount() {
        this.props.dispatch(setVehicleDb([this.props.media.vehicle], this.props.data.vehicle_db))
    }

    generateTitle() {
        var job = ""

        if (this.props.media.profile.Title !== null) {
            job = ", " + this.props.media.profile.Title
        }

        if (this.props.media.profile.Company !== null) {
            if (job === "") {
                job = ", " + this.props.media.profile.Company
            } else {
                job = job + " at " + this.props.media.profile.Company
            }
        }

        return job;
    }

    openBooking() {
        const element = document.getElementById(this.props.datatoggle);
        if (!element) return;

        element.classList.toggle('is-open');

        this.props.dispatch(openPullout(this.props.media))
    }

    render() {
        return (
            <div className = "alert-row">
                <div className = "float-left">
                    {
                        this.props.media.vehicle.Photos != '' ?
                            <img className = "alert-row-image" src={'https://digitalvms.s3.ca-central-1.amazonaws.com/vehicle-images/thumbnails/thumbnail_' + this.props.media.vehicle.Photos} />
                        :
                            <img className = "alert-row-image" src={this.props.settings.images.vehicle_placeholder_square} />
                    }
                </div>
                <div className = "float-left">
                    <span className = "medium">{this.props.media.vehicle.Year} {this.props.media.vehicle.Make} {this.props.media.vehicle.Model} {this.props.media.vehicle.Trim}</span>, <span className = "yellow-warning">{moment(this.props.media.End_Date).from(moment())}</span>
                    <div className = "clearfix"></div>
                    <span className = "caption">{this.props.media.profile.First_Name} {this.props.media.profile.Last_Name}{this.generateTitle()}</span>
                    <div className = "clearfix mb-8"></div>
                    <a className = "link" onClick={this.openBooking}><Trans>See Booking Detail</Trans>s</a>
                </div>
                <div style={{padding:'8px 6px'}} className = "float-left clearfix">
                    {/* CAUSES MAJOR PERFORMANCE ISSUES FOR USERS WITH LARGE NUMBER OF OUTSTANDING MEDIA */}
                    {VCIcon(this.props.media.vehicle.vmh, undefined, undefined, undefined, true)}
                    {DivisionIcon(this.props.media.vehicle.stakeholder, undefined, undefined, undefined, true)}
                </div>
                {
                    this.props.media.has_authorizing ? 
                        <div className = "alert-actions">
                            <div className = "button-group">
                                <MediaActionsComponent match={this.props.match} history={this.props.history} datatoggle={this.props.datatoggle} id={this.props.media.BOOK_ID} media={this.props.media} add_button={true} edit_button={false} dismiss_button={true} />
                            </div>
                        </div>
                    :
                        <span />
                }
                <div className = "clearfix"></div>
            </div>
        )
    }
}

const mapStateToProps = store => ({
    userSession: store.userSession,
    stakeholder: store.stakeholder,
    data: store.data,
    settings: store.settings
});

export default connect(mapStateToProps)(OutstandingMediaRow);